export type NestedKey<T> = {
    [K in keyof T]: T[K] extends object ? `${string & K}.${NestedKey<T[K]>}` : string & K;
}[keyof T];

export const getNestedKeyValue = <T extends Record<string, unknown>, K extends NestedKey<T>, R = string>(obj: T, key: K): R => {
    const result = key
        .split(".")
        .reduce<unknown>(
            (o: unknown, k: string) => (o && (o as Record<string, unknown>)[k] !== undefined ? (o as Record<string, unknown>)[k] : undefined),
            obj,
        );
    return result as R;
};
